import { MenuItem, Typography } from '@mui/material';
import { useMarkupTFunction } from '@retail/markup/i18n';
import { SelectInputField } from '@shared/components';
import { FieldValues, UseControllerReturn } from 'react-hook-form';

export const itemPackageLevelValue = 'ITEM';

interface Props {
  packageOptions: (
    | {
        value: string;
        name: string;
      }
    | {
        value: string | undefined;
        name: string;
        description: string;
      }
  )[];
  gtinController: UseControllerReturn<FieldValues, 'gtin'>;
}

export function SelectPackageLevel({ packageOptions, gtinController }: Props) {
  const t = useMarkupTFunction();
  return (
    <SelectInputField
      menuItems={packageOptions}
      label={t('markup.create.packageLevel.title')}
      {...gtinController.field}
      size="small"
      required
      error={gtinController.fieldState.error?.message}
      placeholder={t('markup.create.packageLevel.placeholder')}
      renderOption={({ value: gtin, name, description: packageUnit }) => {
        if (gtin === itemPackageLevelValue) {
          return (
            <MenuItem value={gtin} key={gtin}>
              {name}
            </MenuItem>
          );
        }
        return (
          <MenuItem
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr',
              rowGap: 0,
            }}
            value={gtin}
            key={gtin}
          >
            <Typography variant="subtitle2">{name}</Typography>
            <Typography variant="body3">{`${packageUnit} - ${gtin}`}</Typography>
          </MenuItem>
        );
      }}
    />
  );
}
